import * as React from 'react';
import { Button, ButtonStyle, IButtonProps } from './Button';
import { Classes, CloseButtonMode } from '../index';
import classNames from 'classnames';
type NavbarProps = Omit<IButtonProps, 'danger' | 'inverse' | 'style'> & {
  style?: Exclude<ButtonStyle, 'primary'>;
  mode?: CloseButtonMode;
};
export const FilterInputButton: React.FC<NavbarProps> = ({
  children,
  className,
  mode,
  dataTest,
  ...props
}) => {
  return (
    <Button
      dataTest={dataTest}
      style={'none'}
      {...props}
      className={classNames(className, Classes.BUTTON_FILTER)}
    >
      {children}
    </Button>
  );
};
